mutation CreateEventEmoteWall(
  $eventId: ID!
  $name: String!
  $twitchChatChannels: [String!]!
  $style: String
  $emoteSize: Int
  $density: Int
  $durationSeconds: Int
  $showTwitchEmotes: Boolean
  $show7tvEmotes: Boolean
  $showBttvEmotes: Boolean
  $showFfzEmotes: Boolean
  $youtubeChatChannels: [String!]
  $blockedWords: [String!]
) {
  wall: StreamToolsCreateEventEmoteWall(
    eventId: $eventId
    name: $name
    twitchChatChannels: $twitchChatChannels
    style: $style
    emoteSize: $emoteSize
    density: $density
    durationSeconds: $durationSeconds
    showTwitchEmotes: $showTwitchEmotes
    show7tvEmotes: $show7tvEmotes
    showBttvEmotes: $showBttvEmotes
    showFfzEmotes: $showFfzEmotes
    youtubeChatChannels: $youtubeChatChannels
    blockedWords: $blockedWords
  ) {
    emoteWallId
    eventId
    name
    twitchChatChannels
    style
    emoteSize
    density
    durationSeconds
    showTwitchEmotes
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    youtubeChatChannels
    blockedWords
    createdAt
  }
}
